/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.unidades': 'Unidades',
  'unidades.agregarUnidades': 'Create Unidades',
  'unidades.modificarUnidades': 'Edit Unidades',
  'unidades.eliminarUnidades': 'Delete Unidades',
  'unidades.unidadId': 'Unidad   Id ',
  'unidades.empresaId': ' Empresa   Id ',
  'unidades.tipoUnidadId': 'Unit type',
  'unidades.descripcionUnidad': ' Descripcion   Unidad ',
  'unidades.descripcionTipoUnidad': ' Descripcion  Unidad type',
  'unidades.abreviatura': ' Abreviatura ',
  'unidades.factor': ' Factor ',
  'unidades.estado': ' Estado',
  'unidades.unidades': 'Unidades',
  'unidades.VerUnidad': 'View Unidades',
  'unidades.TipoUnidadInactivo':'Type unity record is inactive, select a new one.',
};
